class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  cartUpdateUnsubscriber = undefined;
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      },
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
    );

  /*  setTimeout(function() {
       console.log('llll');
         fetchCart();
 }, 1000); */

  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });

      
    
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0,
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            ) || "";
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue,
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`),
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name"),
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      // .catch(() => {
      //   this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      //   const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      //   errors.textContent = window.cartStrings.error;
      // })
      .finally(() => {
        this.disableLoading(line);
      });

            setTimeout(function() {
           var get_amt= $('#shipping_amount').text();
           console.log(isFloat(get_amt));
            if(get_amt!="")
            {
              if(isFloat(get_amt)==true)
              {
                fetchCart();
              }
            }
 }, 800);
    
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      if (message.length > 0) lineItemError.style.display = "flex";
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      ?.querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden"),
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({
              note: document.getElementById("Cart-note").value,
            });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}

 var freeShippingThreshold = $('#shipping_amount').text();
    var cartTotal = 0; // Initialize cart total

    // Function to update the progress bar
    function updateProgressBar() {
      var remainingAmount = freeShippingThreshold - cartTotal;
      var progress = (cartTotal / freeShippingThreshold) * 100;
      var progressBar = document.getElementById('progress-bar');
      var remainingAmountText = document.getElementById('remaining-amount');

      if (cartTotal >= freeShippingThreshold) {
        document.getElementById('free-shipping-progress').style.display = 'none';
      } else {
        document.getElementById('free-shipping-progress').style.display = 'block';
        remainingAmountText.textContent = 'kr ' + remainingAmount.toFixed(2);
        progressBar.style.width = progress + '%';
      }
    }

    // Fetch cart data and update the progress bar
    function fetchCart() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          cartTotal = data.total_price / 100;
          updateProgressBar();
        });
    }

function isFloat(value) {
    // Check if the value is not NaN and is a number
    return !isNaN(value) && parseFloat(value).toString() === value.toString();
}


  const giftWrapCheckbox = document.getElementById("gift-wrap-checkbox");
  const giftWrapVariantId = '42089195471078'; // Replace with actual variant ID

    $('#gift-wrap-checkbox').change(function() {
    //console.log("ioiooo");
  const cartForm = document.querySelector('cart-form');

    if (giftWrapCheckbox.checked) {
    //  console.log("iuiuoiewe");
      // Add Gift Wrap to Cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftWrapVariantId,
          quantity: 1
        })
      }) .then(() =>
cartForm.refresh()) // Reload the cart drawer
.catch(error => console.error('Error adding to cart:', error)); 
  } else {
           // console.log("iuiuoiewe222");

      // Remove Gift Wrap from Cart
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const giftWrapItem = cart.items.find(item => item.id == giftWrapVariantId);
          if (giftWrapItem) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: giftWrapItem.key,
                quantity: 0
              })
            }).then(() =>
cartForm.refresh()) // Reload the cart drawer
.catch(error => console.error('Error updating cart:', error));
          }
        });
       
    }
  });




/*document.addEventListener("DOMContentLoaded", function () {
  const giftWrapCheckbox = document.getElementById("gift-wrap-checkbox");
  const giftWrapVariantId = '42089195471078'; // Replace with actual variant ID

  giftWrapCheckbox.addEventListener("change", function () {
    if (giftWrapCheckbox.checked) {
      // Add Gift Wrap to Cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftWrapVariantId,
          quantity: 1
        })
      }).then(() => {
        location.reload(); // Refresh the cart
      });
    } else {
      // Remove Gift Wrap from Cart
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const giftWrapItem = cart.items.find(item => item.id == giftWrapVariantId);
          if (giftWrapItem) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: giftWrapItem.key,
                quantity: 0
              })
            }).then(() => {
              location.reload(); // Refresh the cart
            });
          }
        });
    }
  });
}); */


function reloadCartDrawer() {
  fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then((html) => {
      const newCartDrawer = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.cart-drawer');
        
      const currentCartDrawer = document.querySelector('.cart-drawer');
      if (currentCartDrawer && newCartDrawer) {
        currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
      }
    })
    .catch(error => console.error('Error reloading cart:', error));
}

$(document).on('change', '#gift-wrap-checkbox', function() {
    const giftWrapVariantId = $(this).data('variant-id'); // Get the variant ID
    const isChecked = $(this).is(':checked');

    if (isChecked) {
        // Add Gift Wrap to Cart
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            data: {
                id: giftWrapVariantId, // Gift wrap variant ID
                quantity: 1
            },
            success: function(response) {
                console.log('Gift wrap added to cart:', response);
                refreshCart(); // Optionally refresh cart
            },
            error: function(xhr) {
                console.error('Failed to add gift wrap:', xhr.responseText);
            }
        });
    } else {
        // Remove Gift Wrap from Cart
        removeGiftWrapFromCart(giftWrapVariantId);
    }
});

function removeGiftWrapFromCart(variantId) {
    // Get the current cart and remove the gift wrap product if present
    $.ajax({
        url: '/cart.js',
        type: 'GET',
        dataType: 'json',
        success: function(cart) {
            const giftWrapItem = cart.items.find(item => item.variant_id == variantId);
            if (giftWrapItem) {
                $.ajax({
                    url: '/cart/change.js',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        id: giftWrapItem.id, // Line item key
                        quantity: 0 // Set quantity to 0 to remove
                    },
                    success: function(response) {
                        console.log('Gift wrap removed from cart:', response);
                        refreshCart(); // Optionally refresh cart
                    },
                    error: function(xhr) {
                        console.error('Failed to remove gift wrap:', xhr.responseText);
                    }
                });
            }
        },
        error: function(xhr) {
            console.error('Failed to fetch cart:', xhr.responseText);
        }
    });
}

function refreshCart() {
    // Example function to refresh the cart dynamically
    $.ajax({
        url: '/cart',
        type: 'GET',
        dataType: 'html',
        success: function(cartHTML) {
            const updatedCart = $(cartHTML).find('#CartDrawer-CartItems'); // Adjust selector for your cart container
            $('#CartDrawer-CartItems').html(updatedCart.html());
             checkGiftWrapInCart();
        },
        error: function() {
            console.error('Failed to refresh cart');
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
  // Initial check on page load
  checkGiftWrapInCart();
});


// Function to check if Gift Wrap exists in cart
  function checkGiftWrapInCart() {
   const giftWrapVariantId = '42089195471078'; // Replace with actual variant ID
     const giftWrapCheckboxContainer = document.querySelector('.gift-wrap-checkbox');

    //console.log("fff");
    fetch('/cart.js') // Fetch cart contents
      .then(response => response.json())
      .then(cart => {

     if (cart.items.length === 0) {
       // console.log("The cart is empty.");
      $(".gift-wrap-checkbox").css("display","none");

        // Perform actions for an empty cart
    } else {
            //  console.log("The cart has items.");

        const giftWrapInCart = cart.items.some(item => item.id == giftWrapVariantId);
        if (giftWrapInCart) {
        //  console.log("dddd");
          // Hide the checkbox if Gift Wrap is already in the cart
          if (giftWrapCheckboxContainer) {
           //    console.log("yeedddd");
            $(".gift-wrap-checkbox").css("display","none");
            giftWrapCheckboxContainer.style.display = 'none';
          }
        } else {
                console.log("dddd222");
         document.getElementById("gift-wrap-checkbox").checked = false;

          // Show the checkbox if Gift Wrap is not in the cart
          if (giftWrapCheckboxContainer) {
               $(".gift-wrap-checkbox").css("display","block");
            giftWrapCheckboxContainer.style.display = 'block';
          }
        }
      }
      })
      .catch(error => console.error('Error checking cart contents:', error));
  }

